import { render, staticRenderFns } from "./setResult.vue?vue&type=template&id=38b9d390&scoped=true"
import script from "./setResult.vue?vue&type=script&lang=ts"
export * from "./setResult.vue?vue&type=script&lang=ts"
import style0 from "./setResult.vue?vue&type=style&index=0&id=38b9d390&prod&lang=scss&scoped=true"
import style1 from "./setResult.vue?vue&type=style&index=1&id=38b9d390&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b9d390",
  null
  
)

export default component.exports